<nav class="navbar navbar-expand-lg navbar-dark main px-3">
  <a class="navbar-brand" routerLink="/home">
    <img src="assets/QuantIP_Logo_white.svg" class="d-inline-block align-top img-fluid logo-img "
      alt="Quant IP Logo">
  </a>

  <button *ngIf="isAuthenticated" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div *ngIf="isAuthenticated" class="collapse navbar-collapse custom-bg" id="navbarSupportedContent">
    <ul  class="navbar-nav me-auto mb-2 mb-lg-0">
      <li class="nav-item">
        <a class="nav-link" routerLink="/idea-generation" routerLinkActive="active"
          ariaCurrentWhenActive="page">Technology Trends</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/company-search" routerLinkActive="active"
          ariaCurrentWhenActive="page">Company Insights</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLink="/thematic-search" routerLinkActive="active"
          ariaCurrentWhenActive="page">Thematic Search</a>
      </li>
      <li class="nav-item" *ngIf="hasTabs$ | async">
        <a class="nav-link" routerLink="/results" routerLinkActive="active"
          ariaCurrentWhenActive="page">Results</a>
      </li>
      <li class="nav-item" *ngIf="roles && roles!.includes('Admin')">
        <a class="nav-link" routerLink="/admin-panel" routerLinkActive="active"
          ariaCurrentWhenActive="page">Admin Panel</a>
      </li>
      <li class="nav-item" *ngIf="roles && (roles!.includes('alpha') || roles!.includes('Admin'))">
        <a class="nav-link" routerLink="/sia-statistics" routerLinkActive="active"
          ariaCurrentWhenActive="page">SIA Statistics</a>
      </li>
      <li class="nav-item" *ngIf="roles && roles!.includes('alpha')">
        <a class="nav-link" routerLink="/pro-bot" routerLinkActive="active"
          ariaCurrentWhenActive="page">"Pro-Bot"</a>
      </li>
      <li class="nav-item" >
        <a class="nav-link" routerLink="/monitoring" routerLinkActive="active"
          ariaCurrentWhenActive="page">Monitoring & Watchlists</a>
      </li>
      <!-- <li class="nav-item" *ngIf="roles && roles!.includes('Admin')">
        <a class="nav-link" routerLink="/demo-bot" routerLinkActive="active"
          ariaCurrentWhenActive="page">Demo-Bot</a>
      </li> -->
    </ul>

    <div class="d-flex">
      <button class="btn btn-primary" style="background:#E5E7EB;color:#1F2937;"
      (click)="logout()">
        Logout
      </button>
    </div>
  </div>
</nav>

<router-outlet></router-outlet>
